import { Factory } from 'fishery';
import { Order } from '@trukt/types/Order';
import { contactFactory } from './contactFactory';
import { stopFactory } from './stopFactory';
import { accountFactory } from './accountFactory';
import { userFactory } from './userFactory';
import { jobFactory } from './jobFactory';
import { terminalFactory } from './terminalFactory';

export const orderFactory = Factory.define<Order>(({ sequence }) => {
  const pickupTerminal = terminalFactory.build({ name: 'Pickup Terminal' });
  const pickupStop = stopFactory.build({ stopType: 'pickup', terminal: pickupTerminal });

  const deliveryTerminal = terminalFactory.build({ name: 'Delivery Terminal' });
  const deliveryStop = stopFactory.build({ stopType: 'delivery', terminal: deliveryTerminal });

  const stops = [pickupStop, deliveryStop];
  const terminals = [pickupTerminal, deliveryTerminal];

  return {
    classification: {
      id: '1',
      label: 'Car Haul',
      isDefault: true,
    },
    bol: '12345678',
    bolUrl: null,
    client: accountFactory.build({ name: 'Order Client' }),
    clientContact: contactFactory.build({ name: 'Order Client Contact' }),
    clientJobBasePay: '150.00',
    consignee: accountFactory.build({ name: 'Order Consignee' }),
    createdByGuid: 'user-1',
    dateCompleted: '2022-01-01T00:00:00.000Z',
    dateCreated: '2022-01-01T00:00:00.000Z',
    dateExpectedCompleteBy: '2022-01-01T00:00:00.000Z',
    dateUpdated: '2022-01-20T00:00:00.000Z',
    dateVerified: '2022-01-01T00:00:00.000Z',
    dispatcher: userFactory.build({ name: 'Order dispatcher' }),
    distance: 100,
    estimatedDistance: '100',
    firstStopGuid: pickupStop.guid,
    guid: sequence.toString(),
    instructions: 'Test Instructions',
    isCanceled: false,
    isComplete: false,
    isDummy: false,
    isOnHold: false,
    isReady: false,
    isTender: false,
    jobs: jobFactory.buildList(2, { stops }),
    lastStopGuid: deliveryStop.guid,
    number: 'LD11117',
    ownerCompanyGuid: 'acertus',
    referenceNumber: '',
    referrer: null,
    salesperson: userFactory.build({ name: 'Order salesperson' }),
    status: 'submitted',
    stops,
    terminals,
    updatedByGuid: '',
    verifiedByGuid: '',
  };
});
